import useRouter from 'js/lib/useRouter';

import { redirectClientOrServer } from 'bundles/common/utils/urlUtils';

const LoginRouteRedirect = () => {
  const router = useRouter();
  redirectClientOrServer(`/programs/${router.params.programSlug}?authMode=login`);

  return null;
};

export default LoginRouteRedirect;
